// Maps Sir Monty catalogue products to real food photography (until Product.image_url is populated).
const U = (id) => `https://images.unsplash.com/photo-${id}?ixlib=rb-4.1.0&auto=format&fit=crop&w=440&h=340&q=70`;
const P = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&fit=crop&w=440&h=340`;

export const CAT_IMG = {
  Pizza: U("1604382354936-07c5d9983bd3"),
  Gelato: U("1618581260815-9371027b9516"),
  Bakery: U("1555507036-ab1f4038808a"),
  Cuisine: U("1603496987674-79600a000f55"),
  Drinks: U("1570696516188-ade861b84a49"),
  Combos: P("4109233"),
};

export const NAME_IMG = {
  "Monty Classic Pizza": U("1604382354936-07c5d9983bd3"),
  "BBQ Chicken Pizza": U("1513104890138-7c749659a591"),
  "Margherita Pizza": U("1593560708920-61dd98c46a4e"),
  "Coconut Gelato": U("1618581260815-9371027b9516"),
  "Dark Choc Gelato": U("1579954115563-e72bf1381629"),
  "Fresh Croissant": U("1555507036-ab1f4038808a"),
  "Monty Meat Pie": U("1599940778173-e276d4acb2bb"),
  "Grilled Chicken & Jollof": U("1603496987674-79600a000f55"),
  "Pepper Soup Chicken": U("1772693471187-6e7d364f99ee"),
  "Zobo Smoothie": U("1570696516188-ade861b84a49"),
  "Fresh Orange Juice": U("1583577612013-4fecf7bf8f13"),
  "Pizza Night Combo": P("4109233"),
};

const FALLBACK = U("1603496987674-79600a000f55");
export function productImage(p) {
  return p.image_url || NAME_IMG[p.name] || CAT_IMG[p.category_name] || CAT_IMG[p.category?.name] || FALLBACK;
}
